import {
  IWidgetConfigurationProps,
  withWidgetConfiguration,
} from "@sgwt-widget/core";
import { IHeader } from "ag-grid-community";
import { h } from "preact";
import { BasicAgGrid } from "../../common/components/AgGrid";
import { ApiBackedScComponent } from "../../common/components/ApiBackedScComponent";
import {
  MakeBookValueAdjustBySalesCall,
  MakeSalesCreditRoleProfile,
} from "../../common/generic/generic-api";
import { GenericFilterBuilder } from "../../common/generic/generic-helper";
import { SCAttributes } from "../../common/generic/generic-sc-attributes";
import { SCKpis } from "../../common/generic/generic-sc-domain";
import { IGenericRequest } from "../../common/generic/generic-types";
import { ConvertFilter, areFiltersCompatible } from "../../common/salescredit/salescredit-filter-help";
import { SCProfileDictionary } from "../../common/salescredit/salescredit-profile-dictionary";
import {
  BuildSalesCreditFilters,
  CreateDateFromFilter,
} from "../../common/salescredit/salescredit-search-criteria";
import { IProps } from "../../common/salescredit/salescredit-types";
import { IBookValueAdjustBySales } from "../../common/utils/AirPnlRetentionRate/AirPnlTypes";
import {
  GetHeaders,
  mapToBookValueAdjustBySales,
} from "../utils/SalesCreditBookValueBySales.helper";

import { fromStyleLocals } from "../../common/utils/css";
import * as style from "./SalesCreditBookValueBySales.less";
import { getTablePptExport } from "../../common/export/table-helper";
import { find } from "lodash";
import { maxSelectedClients } from "../../common/utils/clientlistHelper";
const css = fromStyleLocals(style.locals);

interface IState {
  data: IBookValueAdjustBySales[];
  headers: IHeader[];
}

export class SalesCreditBookValueBySalesClass extends ApiBackedScComponent<
  IProps & IWidgetConfigurationProps,
  IState
> {
  private child: any;
  public constructor() {
    super();
    this.setState({ data: [], headers: [] });
  }

  public getPptExport() {
    const columnsWidth = [3, 1, 1, 2];
    return getTablePptExport(
      this.child._parentComponent.api.gridOptions.api.getDataAsCsv({
        suppressQuotes: true,
        columnSeparator: "¤",
      }),
      columnsWidth
    );
  }

  protected renderWithDataReady(): JSX.Element {
    return (
      <div class={css("ag-grid-header")} style="display:block;height:95%;">
        <BasicAgGrid
          ref={instance => {
            this.child = instance != null ? instance._component : instance;
          }}
          onChange={this.props.onChange}
          rowData={this.state.data}
          columnDefs={this.state.headers}
          fileName={"bvadjust_bysales"}
          showExcelToExport={true}
          showFilterBox={false}
          userSelection={this.props.userSelection}
        />
        <style>{style.toString()}</style>
      </div>
    );
  }

  protected async fetchApiData(props: IProps) {
    this.initCorrelationId();
    this.setDataStatus("loading");
    const userRole = await MakeSalesCreditRoleProfile(
      props.headers,
      this.props.widgetConfiguration,
      undefined,
      this.state.correlationId
    );

    if (userRole.Role === undefined) {
      this.setDataStatus("no-access-rights");
      this.setStatusText(userRole.StatusText);
      return;
    }

    const attributes = `${SCAttributes.SC_FPV_TRADE_NEGO_ENTITY_REGION},${SCAttributes.SC_FPV_TRADE_PC},${SCAttributes.SC_FPV_TRADE_BUMNEMO},${SCAttributes.SC_SALESBEN_SALES}`;
    const sortOrder = "-sc_ytd";

    const filtersConverted = ConvertFilter(props.filters);
    const compatible = areFiltersCompatible(filtersConverted);
    if(compatible && !compatible.valid) {
      this.setDataStatus("incompatible-filters-error");
      this.setStatusText(compatible.attribute);
      return;
    }

    const filters = BuildSalesCreditFilters(filtersConverted);
    const profileDictionary = new SCProfileDictionary();
    const kpis = profileDictionary.GetKpi(userRole.Profile, SCKpis.SC_YTD);
    const finalFilter = GenericFilterBuilder(filters)
      ? GenericFilterBuilder(filters)
      : "";
    const asOfDate = CreateDateFromFilter(filtersConverted);
    const genericRequest: IGenericRequest = {
      aggregationAttributes: attributes,
      date: asOfDate,
      filter: finalFilter,
      kpis,
      sort: sortOrder,
      topN: 30,
    };

    const filterClientsSelected = find(filters, {
      attribute: "clientgen_id",
    });
    const clientsCount = filterClientsSelected
      ? filterClientsSelected.value.split("+").length
      : 0;
    if (filterClientsSelected && clientsCount >= maxSelectedClients) {
      this.setState({
        data: [],
      });
      this.setDataStatus("too-many-clients");
    } else {
      const responseData = await MakeBookValueAdjustBySalesCall(
        props.headers,
        "sc",
        genericRequest,
        this.props.widgetConfiguration,
        this.state.correlationId
      );

      const mappedData = mapToBookValueAdjustBySales(responseData);

      if (mappedData.length > 0) {
        this.setState({
          ...this.state,
          data: mappedData,
          headers: GetHeaders(),
        });
        this.setDataStatus("ready");
      } else {
        this.setState({
          data: [],
          headers: [],
        });
        this.setDataStatus("no-data");
      }
    }
  }
}

export const SalesCreditBookValueBySales = withWidgetConfiguration(
  SalesCreditBookValueBySalesClass
);
